import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function RegisterPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(form);
      toast.success(`Welcome, ${form.name}!`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 grain min-h-screen flex items-center" data-testid="register-page">
      <div className="max-w-md mx-auto w-full px-6">
        <div className="text-center mb-12">
          <div className="eyebrow">Join Luxe Stay</div>
          <h1 className="font-display text-5xl mt-6">Create Account</h1>
          <div className="divider-gold mx-auto" />
        </div>

        <form onSubmit={submit} className="glass-strong p-10 space-y-5" data-testid="register-form">
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Full Name</Label>
            <Input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="register-name-input"
            />
          </div>
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Email</Label>
            <Input
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="register-email-input"
            />
          </div>
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Phone</Label>
            <Input
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="register-phone-input"
            />
          </div>
          <div>
            <Label className="text-xs text-white/60 uppercase tracking-wider">Password</Label>
            <Input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-2 bg-[#0f0f0f] border-white/10 h-12"
              data-testid="register-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full"
            data-testid="register-submit-button"
          >
            {loading ? "Creating..." : "Create Account"}
          </button>

          <div className="text-center text-sm text-white/50">
            Already have an account?{" "}
            <Link to="/login" className="text-gold hover:underline" data-testid="link-to-login">
              Sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
